import {unminifyBrand, unminifyDivision, unminifyCategory, unminifySubcategory} from '../cads/unminify'


const checkCadsForCustomAccess = (cads) => {
  let myCustomerOptions = window.currentUserCustomAccess

  if (myCustomerOptions == null) {
    return false
  } else if (Object.keys(myCustomerOptions).filter(x => cadMatchFields.includes(x)).length == 0) {
    return false
  } else {
    return !cads.some(cad => cadMatch(cad, myCustomerOptions))
  }
}

const cadMatchFields = ['division','category','brand','subCategory']

const cadMatch = (cad, myCustomerOptions) => {
  if (cad == null) return false
  let keys = Object.keys(myCustomerOptions).filter(x => cadMatchFields.includes(x))
  return keys.some(key => myCustomerOptions[key].includes(getCadValue(cad, key)))
}

const getCadValue = (cad, key) => {
  switch(key) {
    case 'division':
      return unminifyDivision(cad.d)
    case 'category':
      return unminifyCategory(cad.g)
    case 'brand':
      return unminifyBrand(cad.b)
    case 'subCategory':
      return unminifySubcategory(cad.e)
    default:
      // code block
  }
}

export {checkCadsForCustomAccess}
